import React from "react";
import {SUMMARY} from "../showcaseData";

export const SummaryScreen: React.FC = () => (
    <div className="dqs-summary">
        <span className="dqs-summary-eyebrow">{SUMMARY.eyebrow}</span>
        <h2 className="dqs-summary-title">{SUMMARY.title}</h2>

        <div className="dqs-summary-grid">
            {SUMMARY.foundations.map((f) => (
                <div className="dqs-foundation" key={f.index}>
                    <span className="dqs-foundation-index">{f.index}</span>
                    <span className="dqs-foundation-label">{f.label}</span>
                    <span className="dqs-foundation-detail">{f.detail}</span>
                </div>
            ))}
        </div>

        <blockquote className="dqs-summary-closing">{SUMMARY.closing}</blockquote>

        <p className="dqs-summary-supporting">{SUMMARY.supporting}</p>
    </div>
);
